import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SubmenuService } from './submenu.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.less']
})
export class SubmenuComponent implements OnInit {

  @ViewChild('myForm') ngForm: NgForm;

  constructor(public submenuService:SubmenuService, private _location:Location) { }

  ngOnInit(): void {
    
  }

  back(){
    this._location.back();
  }

  submit(){
    this.submenuService.submit();
  }

  delete(){
    this.submenuService.delete();
  }

}
